<ng-container *ngIf="!loading">
  <ng-container *ngIf="isHosted && ((isTime ? value <= high : value >= high) || !!demoUser)">
    <div class="db-benchmark-result__checkmark">
      <div>
        <i class="db-icon db-icon-ds-checkmark"></i>
      </div>
    </div>
    <span class="mb8" [innerHTML]="'text_youAreAllSet' | dbText"></span>
  </ng-container>

  <div class="db-benchmark-result">
  <span class="indicator"
        [ngClass]="{
          'indicator': (!isHosted && value) || (isHosted && value && (isTime ? value <= high : value >= high)),
          'low': isTime ? value > low : value < low,
          'average': isTime ? (high < value && value <= low) : (low <= value && value < high)
          }"></span> {{value || '-'}}{{isTime && value ? 's' : !isCurrent ? '+' : ''}}
  </div>
  <ng-container *ngIf="!isHosted">
    <span *ngIf="isCurrent" class="mt8"
          [innerHTML]="(isTime ? value >= high : value <= high) || !value ? 'Needs improvement' : 'You’re all set!'"></span>
    <a *ngIf="!isCurrent && (!compareValue || (isTime ? compareValue >= high : compareValue <= high)) && !userSubscription?.boosterProClient && !userSubscription?.trialBoosterClient" class="mt8"
       (click)="migrate()">Improve with 10Web</a>
    <a *ngIf="!isCurrent && (userSubscription?.boosterProClient || userSubscription?.trialBoosterClient)" class="mt8 on-tenweb-hosting"
    [innerHTML]="'On 10Web hosting'"></a>
    <span *ngIf="!isCurrent && compareValue && !(isTime ? compareValue >= high : compareValue <= high)" class="mt8">You’re all set!</span>
  </ng-container>
</ng-container>


<ng-container *ngIf="loading">
  <span class="ds-spinner-circle"></span>
  <span>{{ 'text_analyzing' | dbText}}…</span>
</ng-container>
